import { createApp } from 'vue'
import SchemaMarkup from './SchemaMarkup'

const el = '.kb-component--schema-markup'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SchemaMarkupDOM) => {
            const props = {
                schemaJson: SchemaMarkupDOM.dataset.schemaJson,
                contentId: SchemaMarkupDOM.dataset.contentId,
                pageUrl: SchemaMarkupDOM.dataset.pageUrl
            }
            const component = createApp(SchemaMarkup, props).use(Store)
            component.mount(SchemaMarkupDOM)
        })
    }
}
